import CoreScroll from '../../mixins/core-scroll'
import CoreResize from '../../mixins/core-resize'


export default
{
    name: 'app-parallax',

    mixins:
    [
        CoreScroll,
        CoreResize
    ],

    props:
    {
        velocity: {type: Number, default: 0.1},
        transform: {type: String, default: ''}
    },

    data()
    {
        return {
            pageUrl: URL.page
        }
    },

    created()
    {
        this._scrollY = 0
    },

    mounted()
    {
        this.onResized(0, this.resize.height)
    },

    methods: {

        onResized(w, h)
        {
            const main = document.body.querySelector('.js-container')
            const top = this.$el.getBoundingClientRect().top - main.getBoundingClientRect().top

            this._posY = top // + this.$el.offsetHeight * 0.5
            this._updateTransform()
        },

        onScroll(y)
        {
            this._y = y
            this._updateTransform()
        },

        _updateTransform()
        {
            const y = (this.$root.isFakeScroll ? this.scroll.smoothY : this.scroll.realY) - this._posY
            const rule = this.transform + ' translateY(' + (y * this.velocity).toFixed(0) + 'px) translateZ(0)'
            
            this.$el.style.transform = rule
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-parallax/script.js